import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
	setupExternalServices,
	setupExternalServicesWithUser,
} from "../AppUtils";
import { initRunDependenciesIfAllowed } from "../externaldependenciesoptout/runDependenciesIfAllowed";

export const WithTracking = ({ children }) => {
	const user = useSelector((state) => state.auth);

	const runDependenciesIfAllowed = initRunDependenciesIfAllowed({
		localStorage: window.localStorage,
		locationHref: window.location.href,
	});

	useEffect(() => {
		runDependenciesIfAllowed(() => {
			setupExternalServices();
		});
	}, []);

	useEffect(() => {
		runDependenciesIfAllowed(() => {
			setupExternalServicesWithUser(user.user);
		});
	}, [user]);

	return <>{children}</>;
};
